import { cn } from '@/utils/cn'
import type { HTMLAttributes } from 'react'

type ChartContainerProps = HTMLAttributes<HTMLDivElement>

export const ChartContainer = ({ className, children, ...props }: ChartContainerProps) => {
  return (
    <div
      className={cn(
        'relative flex items-center justify-center',
        '[&_.recharts-surface]:!w-full [&_.recharts-wrapper]:!w-full',
        '[&_.recharts-layer]:outline-none [&_.recharts-sector]:outline-none [&_.recharts-surface]:outline-none',
        '[&_.recharts-cartesian-axis-tick_text]:fill-body-foreground [&_.recharts-cartesian-axis-tick_text]:text-xs',
        '[&_.recharts-label]:fill-body-foreground [&_.recharts-label]:text-xs',
        '[&_.recharts-curve.recharts-tooltip-cursor]:stroke-border [&_.recharts-rectangle.recharts-tooltip-cursor]:fill-body-foreground',
        "[&_.recharts-cartesian-axis-line]:stroke-border [&_.recharts-cartesian-grid_line[stroke='#ccc']]:stroke-border [&_.recharts-polar-grid_[stroke='#ccc']]:stroke-border [&_.recharts-reference-line_[stroke='#ccc']]:stroke-border",
        "[&_.recharts-dot[stroke='#fff']]:stroke-transparent [&_.recharts-sector[stroke='#fff']]:stroke-transparent",
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}
